import { Client } from "@/Common/Api/Client";
import { FileType } from "@/Common/Models/FileType";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { ExportableFile } from "@/ExportableFile/Models/ExportableFile";
import { FileTypePrescription } from "@/ExportableFile/Models/FileTypes/FileTypePrescription";
import { OverlayElementType } from "@/ExportableFile/Models/OverlayElements/OverlayElement";
import { PrepositionedPharmacyInfoOverlayElement } from "@/ExportableFile/Models/OverlayElements/PrepositionedPharmacyInfoOverlayElement";

interface ExportableFileFaxCallback {
    trigger(exportableFile: ExportableFile, patientContactId: string): Promise<void>;
}

class ExportableFilePreFaxCallbackBuilder {
    public static buildFor(type: FileType): ExportableFileFaxCallback | null {
        switch (type) {
            case FileType.Prescription:
                return new PrescriptionExportableFileFaxCallback();

            default:
                return null;
        }
    }
}

class PrescriptionExportableFileFaxCallback implements ExportableFileFaxCallback {
    public async trigger(exportableFile: ExportableFile, patientContactId: string): Promise<void> {
        const prescriptionExportableFile = exportableFile as FileTypePrescription;

        const faxInfo = prescriptionExportableFile.overlayElements?.firstOrDefault(p => p.overlayElementType === OverlayElementType.PrepositionedPharmacyInfo) as PrepositionedPharmacyInfoOverlayElement;
        if (!faxInfo?.Pharmacy || !faxInfo?.IsSetPreferred)
            return;

        const pharmacy = faxInfo.Pharmacy;
        const request = {
            PatientContactId: patientContactId,
            PharmacyName: pharmacy.Name,
            PharmacyBanner: pharmacy.Banner,
            PharmacyPhone: pharmacy.Phone,
            PharmacyFax: pharmacy.Fax,
            PharmacyAddress: pharmacy.Address
        };

        const response = await Client.postAsync(ServerOperations.Server.Myle_UpdatePreferredPharmacy, request);

        sessionStore.dispatch(LocalPatientOperations.Fax.UpdatePreferredPharmacy, { pharmacy });

        if (!response.isSuccess)
            sessionStore.showPopup(response.errors);
    }
}

export { ExportableFilePreFaxCallbackBuilder };
